import React from 'react';
import './voteriframe.css';

const voteriframe = ({ source }) => {

    if (!source) {
        return <div>Loading...</div>;
    }

    const src = source;     
    return (
        <div className="frame">
            
                <iframe className = "frame"title="Civic resources"src={src}loading="lazy"scrollable ="no"width="100%"marginheight="0" frameborder="0" id="frame2"></iframe>
                
        </div>
    );
};

export default voteriframe;